export default __webpack_public_path__ + "static/media/add.d59cadd5.svg";